
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-sourcing",
      function () {
        return require("private-next-pages/talent-sourcing/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-sourcing"])
      });
    }
  